// src/mocks/handlers/suppliers.handlers.js
import * as data from '../data/suppliers.demo';

export const handle = async (config) => {
    if (config.method === 'put') return { success: true };
    if (/\/suppliers\/\d+/.test(config.url)) return data.supplierDetail;
    return data.supplierList;
};

export const searchByCuit = async () => null;
export const save = async () => ({ success: true, data: {} });
